import Restaurant from "@/views/Restaurant/Restaurant.vue";
import TipCategories from "@/views/Restaurant/TipCategories.vue";
import Menu from "@/views/Restaurant/Menu.vue"
import CenterProduction from "@/views/Restaurant/CenterProduction.vue"
import PlaceTables from "@/views/Restaurant/PlaceTables.vue"

const RestRoute = {
  path: "/restaurant",
  name: "Restaurant",
  component: Restaurant,

  children: [
    {
      path: "type_categories",
      name: "TipCategories",
      component: TipCategories,
      meta: {
        REST: true,
      },
    },
    {
      path: "menu",
      name: "Menu",
      component: Menu,
      meta: {
        REST: true,
      },
    },
    {
      path: "center_production",
      name: "CenterProduction",
      component: CenterProduction,
      meta: {
        REST: true,
      },
    },
    {
      path: "places_tables",
      name: "PlaceTables",
      component: PlaceTables,
      meta: {
        REST: true,
      },
    }
  ],
}


export default RestRoute
